










import { computed, defineComponent } from '@nuxtjs/composition-api'
import SectionWithFooter from '../SectionWithFooter.vue'
import Header from './Header.vue'
import ResearchUseOnly from './ResearchUseOnly.vue'
import ProductInformation from './ProductInformation.vue'
import AdditionalInformation from './AdditionalInformation.vue'
import UsageInformation from './UsageInformation.vue'
import { MappedProduct } from '@/types/product/productTypes'

export default defineComponent({
  components: {
    Header,
    ResearchUseOnly,
    ProductInformation,
    UsageInformation,
    AdditionalInformation,
    SectionWithFooter,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
    size: {
      type: String as () => 'a4' | 'letter',
      required: true,
    },
  },
  setup(props) {
    const revision = computed(() => props.product.attributes.datasheetRevNo!)

    return {
      revision,
    }
  },
})
